var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "folder-list-container select-folder-modal-content copy-assets-destination-view",
    },
    [
      _c("div", { staticClass: "folder-sticky-header" }, [
        _c(
          "div",
          {
            staticClass:
              "d-flex justify-content-between align-items-center mb-3",
          },
          [
            _c("div", { staticClass: "search-container flex-grow-1" }, [
              _c("div", { staticClass: "search-input-wrapper" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchKey,
                      expression: "searchKey",
                    },
                  ],
                  staticClass: "search-input",
                  attrs: { type: "text", placeholder: "Search..." },
                  domProps: { value: _vm.searchKey },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.searchKey = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "svg",
                  {
                    staticClass: "search-icon",
                    attrs: { width: "13", height: "13" },
                  },
                  [
                    _c("use", {
                      attrs: { href: "/img/icons/sprite.svg#search-big" },
                    }),
                  ]
                ),
                _vm._v(" "),
                _vm.searchKey
                  ? _c(
                      "button",
                      {
                        staticClass: "clear-search-btn",
                        on: { click: _vm.clearSearch },
                      },
                      [_c("i", { staticClass: "cil-x" })]
                    )
                  : _vm._e(),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "d-flex justify-content-between align-items-center mb-3",
          },
          [
            _c("BreadcrumbItem", {
              attrs: { breadcrumbs: _vm.breadcrumbs },
              on: { goTo: _vm.goToFolder },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "folder-scroll-area" },
        [
          _vm.isListLoading
            ? [
                _c(
                  "div",
                  { staticClass: "folders-grid" },
                  _vm._l(_vm.pageSize, function (n) {
                    return _c(
                      "div",
                      {
                        key: n,
                        staticClass: "w-100 h-100",
                        staticStyle: { "min-height": "167px" },
                      },
                      [
                        _c("b-skeleton", {
                          attrs: { width: "100%", height: "88%" },
                        }),
                        _vm._v(" "),
                        _c("b-skeleton"),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]
            : _vm.paginatedFolders.length || _vm.fileItems.length
            ? [
                _vm.paginatedFolders.length
                  ? _c(
                      "div",
                      { staticClass: "section-container" },
                      [
                        _c("ItemGrid", {
                          staticClass: "folder-items folders-grid",
                          attrs: {
                            items: _vm.paginatedFolders,
                            "is-selected": (folder) =>
                              _vm.selectedFolderId === folder.id,
                            columns: 4,
                            gap: 16,
                            "item-props": { isAvailableOverlay: false },
                          },
                          on: {
                            "item-click": _vm.selectFolder,
                            "item-dblclick": (folder) =>
                              _vm.navigateToFolder(folder.id),
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isSaveMode && _vm.fileItems.length
                  ? _c(
                      "div",
                      { staticClass: "section-container" },
                      [
                        _c("ItemGrid", {
                          staticClass: "folders-grid",
                          attrs: {
                            items: _vm.fileItems,
                            columns: 4,
                            gap: 16,
                            "item-props": { isAvailableOverlay: false },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : [
                _c("b-alert", { attrs: { show: "", variant: "warning" } }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.searchKey
                          ? `No folders found matching "${_vm.searchKey}"`
                          : "This folder is empty"
                      ) +
                      "\n      "
                  ),
                ]),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _vm.showPagination
        ? _c("div", { staticClass: "folder-sticky-footer" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-center align-items-center item-pagination",
              },
              [
                _c("ItemPagination", {
                  attrs: {
                    "total-rows": _vm.paginationTotalRows,
                    "per-page": _vm.pageSize,
                    disabled: _vm.isListLoading,
                  },
                  on: { change: _vm.onPageChange },
                  model: {
                    value: _vm.currentPage,
                    callback: function ($$v) {
                      _vm.currentPage = $$v
                    },
                    expression: "currentPage",
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }